"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _paymentSettings = require("@/api/appBasicSetup/paymentSettings");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var emptyAccountForm = function emptyAccountForm() {
  return {
    confId: null,
    dealerId: '',
    brokerId: '',
    yzh3DesKey: '',
    yzhAppKey: '',
    yzhRsaPublicKey: ''
  };
};
var _default = exports.default = {
  name: 'CloudTransferConfig',
  data: function data() {
    return {
      loading: false,
      // 大额转账渠道配置（LARGE_TRANSFER_CHANNEL）：启用开关 + 打款策略
      largeTransferConfig: {
        enable: 0,
        amount: '',
        channel: ''
      },
      // 第三方渠道独立配置子 tab：'cloudTransfer' 云转账配置
      cloudSubTab: 'cloudTransfer',
      // 云账户配置列表
      accountList: [],
      total: 0,
      page: 1,
      size: 10,
      // 添加账号 / 账号管理弹窗
      accountDialogVisible: false,
      accountDialogMode: 'add',
      accountForm: emptyAccountForm(),
      accountDetail: null,
      accountRules: {
        dealerId: [{
          required: true,
          message: '请输入平台企业ID',
          trigger: 'blur'
        }],
        brokerId: [{
          required: true,
          message: '请输入综合服务主体ID',
          trigger: 'blur'
        }],
        yzhAppKey: [{
          required: true,
          message: '请输入App Key',
          trigger: 'blur'
        }],
        yzh3DesKey: [{
          required: true,
          message: '请输入3DES Key',
          trigger: 'blur'
        }],
        yzhRsaPublicKey: [{
          required: true,
          message: '请输入云账户公钥',
          trigger: 'blur'
        }]
      },
      // 手动录入 / 手动修改平台密钥弹窗
      cloudKeysDialogVisible: false,
      cloudKeysForm: {
        platformRsaPublicKey: '',
        platformRsaPrivateKey: ''
      },
      cloudKeysRules: {
        platformRsaPublicKey: [{
          required: true,
          message: '请输入平台公钥',
          trigger: 'blur'
        }],
        platformRsaPrivateKey: [{
          required: true,
          message: '请输入平台私钥',
          trigger: 'blur'
        }]
      },
      // 新密钥对一次性展示弹窗
      cloudNewKeysDialogVisible: false,
      cloudNewKeysForm: {
        platformRsaPublicKey: '',
        platformRsaPrivateKey: ''
      }
    };
  },
  computed: {
    // 当前应用 / 用户上下文，请求头中已携带，这里同时按接口约定显式传参
    commonParams: function commonParams() {
      var appId = this.$store.getters.appId;
      var userId = this.$store.getters.userId;
      var params = {};
      if (appId !== '' && appId !== null && appId !== undefined) params.appId = appId;
      if (userId !== '' && userId !== null && userId !== undefined) params.userId = userId;
      return params;
    },
    // 详情中是否已配置平台密钥
    accountHasKeys: function accountHasKeys() {
      return !!(this.accountDetail && this.accountDetail.platformRsaPublicKey);
    }
  },
  created: function created() {
    this.queryCloudTransferConfig();
  },
  methods: {
    // ==================== 打款策略 ====================
    queryCloudTransferConfig: function () {
      var _queryCloudTransferConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return this.queryLargeTransferConfig();
            case 1:
              if (!(this.largeTransferConfig.enable === 1)) {
                _context.n = 2;
                break;
              }
              _context.n = 2;
              return this.queryYzhConfPage();
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.loading = false;
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[0, 3]]);
      }));
      function queryCloudTransferConfig() {
        return _queryCloudTransferConfig.apply(this, arguments);
      }
      return queryCloudTransferConfig;
    }(),
    // 查询大额转账渠道配置（LARGE_TRANSFER_CHANNEL）
    queryLargeTransferConfig: function () {
      var _queryLargeTransferConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var res, c;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _paymentSettings.queryTenantBizConfig)({
                configKey: 'LARGE_TRANSFER_CHANNEL'
              });
            case 1:
              res = _context2.v;
              if (res.code === 0 && res.data && res.data.config) {
                c = res.data.config;
                this.largeTransferConfig = {
                  enable: Number(c.enable) === 1 ? 1 : 0,
                  amount: c.amount !== undefined && c.amount !== null ? c.amount : '',
                  channel: Number(c.channel) ? Number(c.channel) : ''
                };
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function queryLargeTransferConfig() {
        return _queryLargeTransferConfig.apply(this, arguments);
      }
      return queryLargeTransferConfig;
    }(),
    // 保存大额转账渠道配置（LARGE_TRANSFER_CHANNEL），返回是否成功
    saveLargeTransferConfig: function () {
      var _saveLargeTransferConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _paymentSettings.saveTenantBizConfig)({
                configKey: 'LARGE_TRANSFER_CHANNEL',
                config: {
                  enable: Number(this.largeTransferConfig.enable) === 1 ? 1 : 0,
                  amount: Number(this.largeTransferConfig.amount) || 0,
                  channel: Number(this.largeTransferConfig.channel)
                }
              });
            case 1:
              res = _context3.v;
              if (!(res.code !== 0)) {
                _context3.n = 2;
                break;
              }
              this.$message.error(res.msg || '保存失败');
              return _context3.a(2, false);
            case 2:
              return _context3.a(2, true);
          }
        }, _callee3, this);
      }));
      function saveLargeTransferConfig() {
        return _saveLargeTransferConfig.apply(this, arguments);
      }
      return saveLargeTransferConfig;
    }(),
    // 启用/关闭云账户打款 val: 1 开启、0 关闭
    onCloudEnabledChange: function onCloudEnabledChange(val) {
      var _this = this;
      var isOpen = Number(val) === 1;
      var tip = isOpen ? '开启后将按照下方打款策略自动分配提现打款通道，确定开启吗？' : '关闭后第三方打款渠道将停止使用，确定关闭吗？';
      this.$confirm(tip, '温馨提示', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var ok;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this.saveLargeTransferConfig();
            case 1:
              ok = _context4.v;
              if (ok) {
                _this.$message.success(isOpen ? '已开启' : '已关闭');
                if (isOpen) _this.queryYzhConfPage();
              } else {
                _this.largeTransferConfig.enable = isOpen ? 0 : 1;
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))).catch(function () {
        _this.largeTransferConfig.enable = isOpen ? 0 : 1;
      });
    },
    // 保存打款策略
    onSaveCloudStrategy: function onSaveCloudStrategy() {
      var _this2 = this;
      var amount = Number(this.largeTransferConfig.amount);
      if (this.largeTransferConfig.amount === '' || isNaN(amount) || amount <= 0) {
        this.$message.error('请输入正确的提现金额');
        return;
      }
      if (!this.largeTransferConfig.channel) {
        this.$message.error('请选择打款服务');
        return;
      }
      this.$confirm('保存后打款策略将立即生效，是否继续？', '保存配置信息', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var ok;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this2.largeTransferConfig.amount = amount;
              _context5.n = 1;
              return _this2.saveLargeTransferConfig();
            case 1:
              ok = _context5.v;
              if (ok) _this2.$message.success('保存成功');
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))).catch(function () {});
    },
    // ==================== 账号管理列表 ====================
    // 分页查询云账户配置列表
    queryYzhConfPage: function () {
      var _queryYzhConfPage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var res, _t2;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              this.loading = true;
              _context6.p = 1;
              _context6.n = 2;
              return (0, _paymentSettings.queryYzhConfPage)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.commonParams), {}, {
                page: this.page,
                size: this.size
              }));
            case 2:
              res = _context6.v;
              if (res.code === 0 && res.data) {
                this.accountList = res.data.data || [];
                this.total = Number(res.data.total) || 0;
              }
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t2 = _context6.v;
            case 4:
              _context6.p = 4;
              this.loading = false;
              return _context6.f(4);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this, [[1, 3, 4, 5]]);
      }));
      function queryYzhConfPage() {
        return _queryYzhConfPage2.apply(this, arguments);
      }
      return queryYzhConfPage;
    }(),
    onPageSizeChange: function onPageSizeChange(size) {
      this.size = size;
      this.page = 1;
      this.queryYzhConfPage();
    },
    onPageChange: function onPageChange(page) {
      this.page = page;
      this.queryYzhConfPage();
    },
    // 设为使用
    onActiveAccount: function onActiveAccount(row) {
      var _this3 = this;
      this.$confirm('确定将该账号设为使用吗？', '设为使用', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var res, _t3;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return (0, _paymentSettings.activeYzhConf)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this3.commonParams), {}, {
                confId: row.confId
              }));
            case 1:
              res = _context7.v;
              if (!(res.code !== 0)) {
                _context7.n = 2;
                break;
              }
              _this3.$message.error(res.msg || '设置失败');
              return _context7.a(2);
            case 2:
              _this3.$message.success('设置成功');
              _this3.queryYzhConfPage();
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t3 = _context7.v;
            case 4:
              return _context7.a(2);
          }
        }, _callee7, null, [[0, 3]]);
      }))).catch(function () {});
    },
    // 同步余额
    onSyncBalance: function onSyncBalance(row) {
      var _this4 = this;
      this.$confirm('确定同步该账号的云账户余额吗？', '余额同步', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8() {
        var res, _t4;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              _this4.loading = true;
              _context8.n = 1;
              return (0, _paymentSettings.syncYzhConfBalance)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this4.commonParams), {}, {
                confId: row.confId
              }));
            case 1:
              res = _context8.v;
              if (!(res.code !== 0)) {
                _context8.n = 2;
                break;
              }
              _this4.$message.error(res.msg || '余额同步失败');
              return _context8.a(2);
            case 2:
              _this4.$message.success('余额同步成功');
              _this4.queryYzhConfPage();
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t4 = _context8.v;
            case 4:
              _context8.p = 4;
              _this4.loading = false;
              return _context8.f(4);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, null, [[0, 3, 4, 5]]);
      }))).catch(function () {});
    },
    // 删除账号
    onDeleteAccount: function onDeleteAccount(row) {
      var _this5 = this;
      this.$confirm('确定要删除该账号吗？删除后将无法恢复。', '删除账号', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee9() {
        var res, _t5;
        return (0, _regenerator2.default)().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              _context9.n = 1;
              return (0, _paymentSettings.deleteYzhConf)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this5.commonParams), {}, {
                confId: row.confId
              }));
            case 1:
              res = _context9.v;
              if (!(res.code !== 0)) {
                _context9.n = 2;
                break;
              }
              _this5.$message.error(res.msg || '删除失败');
              return _context9.a(2);
            case 2:
              _this5.$message.success('删除成功');
              if (_this5.accountList.length === 1 && _this5.page > 1) _this5.page--;
              _this5.queryYzhConfPage();
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t5 = _context9.v;
            case 4:
              return _context9.a(2);
          }
        }, _callee9, null, [[0, 3]]);
      }))).catch(function () {});
    },
    // ==================== 配置账号弹窗 ====================
    // 添加账号
    onAddAccount: function onAddAccount() {
      this.accountDialogMode = 'add';
      this.accountForm = emptyAccountForm();
      this.accountDetail = null;
      this.accountDialogVisible = true;
      this.clearAccountFormValidate();
    },
    // 配置（先查详情再回显）
    onConfigAccount: function () {
      var _onConfigAccount = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee0(row) {
        var res, _t6;
        return (0, _regenerator2.default)().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              _context0.p = 0;
              this.loading = true;
              _context0.n = 1;
              return (0, _paymentSettings.queryYzhConfDetail)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.commonParams), {}, {
                confId: row.confId
              }));
            case 1:
              res = _context0.v;
              if (!(res.code !== 0 || !res.data)) {
                _context0.n = 2;
                break;
              }
              this.$message.error(res.msg || '查询配置详情失败');
              return _context0.a(2);
            case 2:
              this.accountDialogMode = 'edit';
              this.accountDetail = res.data;
              this.accountForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, emptyAccountForm()), {}, {
                confId: res.data.confId,
                dealerId: res.data.dealerId || '',
                brokerId: res.data.brokerId || '',
                yzh3DesKey: res.data.yzh3DesKey || '',
                yzhAppKey: res.data.yzhAppKey || '',
                yzhRsaPublicKey: res.data.yzhRsaPublicKey || ''
              });
              this.accountDialogVisible = true;
              this.clearAccountFormValidate();
              _context0.n = 4;
              break;
            case 3:
              _context0.p = 3;
              _t6 = _context0.v;
            case 4:
              _context0.p = 4;
              this.loading = false;
              return _context0.f(4);
            case 5:
              return _context0.a(2);
          }
        }, _callee0, this, [[0, 3, 4, 5]]);
      }));
      function onConfigAccount(_x) {
        return _onConfigAccount.apply(this, arguments);
      }
      return onConfigAccount;
    }(),
    onAccountDialogClose: function onAccountDialogClose() {
      this.accountDialogVisible = false;
      this.accountForm = emptyAccountForm();
      this.accountDetail = null;
      this.clearAccountFormValidate();
    },
    clearAccountFormValidate: function clearAccountFormValidate() {
      var _this6 = this;
      this.$nextTick(function () {
        if (_this6.$refs.accountForm) _this6.$refs.accountForm.clearValidate();
      });
    },
    // 保存第三方对接参数（新增时返回 confId）
    onSaveAccountConfig: function onSaveAccountConfig() {
      var _this7 = this;
      this.$refs.accountForm.validate(/*#__PURE__*/function () {
        var _ref6 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee1(valid) {
          var cmd, res, _t7;
          return (0, _regenerator2.default)().w(function (_context1) {
            while (1) switch (_context1.p = _context1.n) {
              case 0:
                if (valid) {
                  _context1.n = 1;
                  break;
                }
                _this7.$message.error('请填写所有必填项');
                return _context1.a(2);
              case 1:
                cmd = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this7.commonParams), {}, {
                  dealerId: _this7.accountForm.dealerId,
                  brokerId: _this7.accountForm.brokerId,
                  yzh3DesKey: _this7.accountForm.yzh3DesKey,
                  yzhAppKey: _this7.accountForm.yzhAppKey,
                  yzhRsaPublicKey: _this7.accountForm.yzhRsaPublicKey
                });
                if (_this7.accountForm.confId) cmd.confId = _this7.accountForm.confId;
                _context1.p = 2;
                _this7.loading = true;
                _context1.n = 3;
                return (0, _paymentSettings.saveYzhConf)(cmd);
              case 3:
                res = _context1.v;
                if (!(res.code !== 0)) {
                  _context1.n = 4;
                  break;
                }
                _this7.$message.error(res.msg || '保存失败');
                return _context1.a(2);
              case 4:
                _this7.$message.success('保存成功');
                if (!_this7.accountForm.confId && res.data) _this7.accountForm.confId = res.data;
                _context1.n = 5;
                return Promise.all([_this7.refreshAccountDetail(), _this7.queryYzhConfPage()]);
              case 5:
                _context1.n = 7;
                break;
              case 6:
                _context1.p = 6;
                _t7 = _context1.v;
              case 7:
                _context1.p = 7;
                _this7.loading = false;
                return _context1.f(7);
              case 8:
                return _context1.a(2);
            }
          }, _callee1, null, [[2, 6, 7, 8]]);
        }));
        return function (_x2) {
          return _ref6.apply(this, arguments);
        };
      }());
    },
    // 重新查询详情，刷新平台密钥展示
    refreshAccountDetail: function () {
      var _refreshAccountDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee10() {
        var res;
        return (0, _regenerator2.default)().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (this.accountForm.confId) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              _context10.n = 2;
              return (0, _paymentSettings.queryYzhConfDetail)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.commonParams), {}, {
                confId: this.accountForm.confId
              }));
            case 2:
              res = _context10.v;
              if (res.code === 0 && res.data) this.accountDetail = res.data;
            case 3:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function refreshAccountDetail() {
        return _refreshAccountDetail.apply(this, arguments);
      }
      return refreshAccountDetail;
    }(),
    // ==================== 平台专属密钥 ====================
    // 未保存参数前不允许录入 / 生成密钥
    canEditKeys: function canEditKeys() {
      if (this.accountForm.confId) return true;
      this.$confirm('请先保存上方的“第三方对接参数”，再尝试生成平台密钥对', '密钥对生成确认', {
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: '知道了'
      }).catch(function () {});
      return false;
    },
    // 手动录入 / 手动修改
    onOpenKeyManualDialog: function onOpenKeyManualDialog() {
      var _this8 = this;
      if (!this.canEditKeys()) return;
      this.cloudKeysForm = {
        platformRsaPublicKey: '',
        platformRsaPrivateKey: ''
      };
      this.cloudKeysDialogVisible = true;
      this.$nextTick(function () {
        if (_this8.$refs.cloudKeysForm) _this8.$refs.cloudKeysForm.clearValidate();
      });
    },
    onCloudKeysConfirm: function onCloudKeysConfirm() {
      var _this9 = this;
      this.$refs.cloudKeysForm.validate(function (valid) {
        if (!valid) {
          _this9.$message.error('请填写所有必填项');
          return;
        }
        _this9.$confirm('替换密钥后，请务必前往云账户平台更新公钥，确定保存吗？', '手动修改平台密钥', {
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee11() {
          var res, _t8;
          return (0, _regenerator2.default)().w(function (_context11) {
            while (1) switch (_context11.p = _context11.n) {
              case 0:
                _context11.p = 0;
                _this9.loading = true;
                _context11.n = 1;
                return (0, _paymentSettings.saveYzhConfKey)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this9.commonParams), {}, {
                  confId: _this9.accountForm.confId,
                  platformRsaPublicKey: _this9.cloudKeysForm.platformRsaPublicKey,
                  platformRsaPrivateKey: _this9.cloudKeysForm.platformRsaPrivateKey
                }));
              case 1:
                res = _context11.v;
                if (!(res.code !== 0)) {
                  _context11.n = 2;
                  break;
                }
                _this9.$message.error(res.msg || '保存失败');
                return _context11.a(2);
              case 2:
                _this9.$message.success('保存成功');
                _this9.onCloudKeysDialogClose();
                _context11.n = 3;
                return _this9.refreshAccountDetail();
              case 3:
                _context11.n = 5;
                break;
              case 4:
                _context11.p = 4;
                _t8 = _context11.v;
              case 5:
                _context11.p = 5;
                _this9.loading = false;
                return _context11.f(5);
              case 6:
                return _context11.a(2);
            }
          }, _callee11, null, [[0, 4, 5, 6]]);
        }))).catch(function () {});
      });
    },
    onCloudKeysDialogClose: function onCloudKeysDialogClose() {
      var _this0 = this;
      this.cloudKeysDialogVisible = false;
      this.cloudKeysForm = {
        platformRsaPublicKey: '',
        platformRsaPrivateKey: ''
      };
      this.$nextTick(function () {
        if (_this0.$refs.cloudKeysForm) _this0.$refs.cloudKeysForm.clearValidate();
      });
    },
    // 一键生成 / 重新生成
    onRegenerateKeys: function onRegenerateKeys() {
      var _this1 = this;
      if (!this.canEditKeys()) return;
      this.$confirm('确定生成平台密钥对？', '密钥对生成确认', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _this1.doGenerateKeys();
      }).catch(function () {});
    },
    doGenerateKeys: function () {
      var _doGenerateKeys = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee12() {
        var res, _t9;
        return (0, _regenerator2.default)().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              _context12.p = 0;
              this.loading = true;
              // 不传公私钥时，由后端新生成密钥对
              _context12.n = 1;
              return (0, _paymentSettings.saveYzhConfKey)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.commonParams), {}, {
                confId: this.accountForm.confId
              }));
            case 1:
              res = _context12.v;
              if (!(res.code !== 0 || !res.data)) {
                _context12.n = 2;
                break;
              }
              this.$message.error(res.msg || '密钥生成失败');
              return _context12.a(2);
            case 2:
              this.cloudNewKeysForm = {
                platformRsaPublicKey: res.data.platformRsaPublicKey || '',
                platformRsaPrivateKey: res.data.platformRsaPrivateKey || ''
              };
              this.cloudNewKeysDialogVisible = true;
              this.$message.success('密钥生成成功，请前往云账户平台更新公钥');
              _context12.n = 3;
              return this.refreshAccountDetail();
            case 3:
              _context12.n = 5;
              break;
            case 4:
              _context12.p = 4;
              _t9 = _context12.v;
            case 5:
              _context12.p = 5;
              this.loading = false;
              return _context12.f(5);
            case 6:
              return _context12.a(2);
          }
        }, _callee12, this, [[0, 4, 5, 6]]);
      }));
      function doGenerateKeys() {
        return _doGenerateKeys.apply(this, arguments);
      }
      return doGenerateKeys;
    }(),
    onCloudNewKeysDialogClose: function onCloudNewKeysDialogClose() {
      this.cloudNewKeysDialogVisible = false;
      this.cloudNewKeysForm = {
        platformRsaPublicKey: '',
        platformRsaPrivateKey: ''
      };
    },
    // 复制公钥 / 私钥
    onCopyKey: function onCopyKey(text) {
      this.copyText(text);
    },
    copyText: function copyText(text) {
      var _this10 = this;
      if (!text) return;
      var doFallback = function doFallback() {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        _this10.$message.success('复制成功');
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          _this10.$message.success('复制成功');
        }).catch(function () {
          return doFallback();
        });
      } else {
        doFallback();
      }
    }
  }
};